<script lang="ts">
    export let percentage = 0
    export let strokeWidth = 10
    export let colorTransformer: (percentage: number) => string = (
        percentage
    ) => {
        if (percentage < 0.25) return "brown"
        if (percentage < 0.5) return "orange"
        if (percentage < 0.75) return "teal"
        else return "green"
    }

    const circumference = 2 * Math.PI * 50 // 50 is the radius of the circle
    $: dashArray = `${percentage * circumference} ${
        circumference - percentage * circumference
    }`
</script>

<svg viewBox="0 0 100 100" {...$$restProps}>
    <circle
        role="progressbar"
        cx="50"
        cy="50"
        r={50 - strokeWidth / 2}
        stroke={colorTransformer(percentage)}
        stroke-width={strokeWidth}
        fill="none"
        stroke-dasharray={dashArray}
        stroke-dashoffset={circumference * 0.333}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percentage * 100}
        aria-label="relevance"
    />
</svg>
